import { JSX } from 'react'

import { IconProps } from '../../icon'

const HistoriaArte: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.0167 27.81L30.975 22.0075L25.1105 32.3175H36.0167V27.81Z'
      fill='#AAD3DC'
    />
    <path
      d='M24.4997 23.067C25.9833 23.067 27.186 21.8643 27.186 20.3807C27.186 18.8971 25.9833 17.6945 24.4997 17.6945C23.0162 17.6945 21.8135 18.8971 21.8135 20.3807C21.8135 21.8643 23.0162 23.067 24.4997 23.067Z'
      fill='#F9D865'
    />
    <path d='M16.2735 32.4713L20.1307 25.8125L24.3495 32.3175' fill='#D7D861' />
    <path
      d='M34.346 40L31.2973 34.919H24.316V39.78H23.4613V34.919H16.7622L13.7135 40L12.9808 39.5602L15.7655 34.9193H9.5V11.7822H19.3628V9.9695H22.4272V8H25.6323V9.9695H28.6968V11.7825H38.5595V34.9193H32.294L35.0788 39.5602L34.346 40ZM10.3548 34.0643H37.7048V12.637H10.3548V34.0643ZM20.2175 11.7822H27.842V10.824H20.2175V11.7822ZM23.282 9.9695H24.7777V8.85475H23.282V9.9695ZM36.444 32.733H11.686V13.9682H36.444V32.733ZM25.852 31.8783H35.5893V27.97L31.0483 22.743L25.852 31.8783ZM24.5743 31.8783H24.869L30.9023 21.2715L35.5895 26.6667V14.823H12.5408V31.8785H16.1233L20.1102 24.9955L24.5743 31.8783ZM17.1108 31.8783H23.5553L20.1515 26.6295L17.1108 31.8783ZM24.4997 23.4943C22.783 23.4943 21.3862 22.0975 21.3862 20.381C21.3862 18.664 22.783 17.2673 24.4997 17.2673C26.2165 17.2673 27.6133 18.664 27.6133 20.381C27.6133 22.0975 26.2165 23.4943 24.4997 23.4943ZM24.4997 18.122C23.2542 18.122 22.241 19.1353 22.241 20.381C22.241 21.6262 23.2542 22.6395 24.4997 22.6395C25.7452 22.6395 26.7585 21.6262 26.7585 20.381C26.7588 19.1353 25.7455 18.122 24.4997 18.122Z'
      fill='black'
    />
  </svg>
)

export default HistoriaArte
